import { useState , useEffect } from "react";
import { createContext } from "react";

export const HotelOurContext = createContext({
    HotelOurMap:[],
})

export const HotelOurProvider = ({children})=>{
    const [HotelOurMap , setHotelOurMap] = useState([])
    useEffect(() => {
        // API endpoint disabled - using empty array
        // fetch("https://api.reverhotel.uz/rooms")
        // .then(res => res.json())
        // .then(result => setHotelOurMap(result))
    }, []) // Fixed: removed HotelOurMap from dependency to prevent infinite loop
    const value = {HotelOurMap};
    return(
        <HotelOurContext.Provider value={value}>{children}</HotelOurContext.Provider>
    )
}